import axios from 'axios';

class modelDetailsService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getDefaultModel(lookerParams) {
        return axios
            .post(this.state.apiUrl + 'model/getDefaultModel', JSON.stringify(lookerParams))
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getModelsList(searchKey, modelId) {
        const url = this.state.apiUrl + 'model/search?name=' + searchKey + '&modelId=' + modelId;
        if (url.includes(this.state.apiUrl + 'model/search?name=' + searchKey + '&modelId=' + modelId)) {
            return axios
                .get(this.state.apiUrl + 'model/search?name=' + searchKey + '&modelId=' + modelId)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getSingleModel(param) {
        return axios.post(this.state.apiUrl + 'model/getModel', JSON.stringify(param)).then((res) => {
            return res.data;
        });
    }

    deleteModel(param) {
        return axios
            .delete(this.state.apiUrl + 'model/delete/' + param.modelId + '/' + param.modelVersionId)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    saveUpdateModel(params) {
        return axios
            .post(this.state.apiUrl + 'model/save', JSON.stringify(params))
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    renameModelOrVersion(params) {
        return axios
            .put(this.state.apiUrl + 'model/rename', JSON.stringify(params))
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getPharmacyDetails(params) {
        return axios
            .get(this.state.apiUrl + 'home/getPharmacyDetails?params=' + JSON.stringify(params))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }

    getCustomerDrugNonAccessList(params) {
        return axios
            .get(this.state.apiUrl + 'home/getCustomerDrugNonAccessList?params=' + JSON.stringify(params))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }

    getRXNonFilteredDateList(params) {
        return axios
            .get(this.state.apiUrl + 'home/getRXNonFilteredDateList?params=' + JSON.stringify(params))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }

    getRXOrderDate(params) {
        return axios
            .get(this.state.apiUrl + 'home/getRXOrderDate?params=' + JSON.stringify(params))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }

    loadMedOrder(params) {
        return axios
            .post(this.state.apiUrl + 'home/loadMedOrder', JSON.stringify(params))
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err;
            });
    }
}

export default modelDetailsService;
